import { type TenantMetadata, tenantMetadata } from '@newo/tenant-metadata';

export class PartnerMetadata {
	private get metadata(): TenantMetadata {
		return tenantMetadata.metadata;
	}

	private getBranding(): TenantMetadata['branding'] {
		return this.metadata.branding;
	}

	private getFeatureFlags(): TenantMetadata['feature_flags'] {
		return this.metadata.feature_flags;
	}

	public getId(): string {
		return this.metadata.id;
	}

	public getName(): string {
		return this.metadata.name;
	}

	public getDarkLogoUrl(preferSvg = false): string {
		const logo = this.getBranding().logo.dark;

		if (preferSvg) {
			return logo.svg ?? '';
		}

		return logo.png ?? '';
	}

	public isLocalizationEnabled(): boolean {
		return this.getFeatureFlags().is_localization_enabled;
	}
}

export const partnerMetadata = new PartnerMetadata();
